// extracted by mini-css-extract-plugin
module.exports = {"root":"scroll_root__3BDUq"};